/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InventoryStorePathParams, InventoryStoreRequest, InventoryStoreResponse } from '../types/InventoryStore'

/**
 * POST /:organisation/inventory
 * @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::store
 */
export async function inventoryStore(
	organisation: InventoryStorePathParams['organisation'],
	data: InventoryStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InventoryStoreResponse>> {
	return axiosInstance.post(`/${organisation}/inventory`, data, config)
}
